import { ReactNode } from 'react'

export interface NavTabProps {
  icon: ReactNode
  label: string
  route?: string
  active?: boolean
  onClick?: () => void
  badge?: boolean
  badgeCount?: number
  disabled?: boolean
}

export function NavTab({ icon, label, active, onClick, disabled }: NavTabProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex flex-col items-center justify-center gap-1 py-2 px-4 transition-colors ${
        disabled
          ? 'text-gray-400 cursor-not-allowed'
          : active
          ? 'text-toast-gold'
          : 'text-charcoal-gray hover:text-toast-gold'
      }`}
    >
      <span className="text-xl">{icon}</span>
      <span className="text-xs font-medium">{label}</span>
    </button>
  )
}

export interface BottomNavProps {
  children: ReactNode
  className?: string
}

export function BottomNav({ children, className = '' }: BottomNavProps) {
  return (
    <nav
      className={`fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-inset-bottom z-50 ${className}`}
    >
      <div className="max-w-md mx-auto flex justify-around items-center">
        {children}
      </div>
    </nav>
  )
}
